import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import type {WaypointPreview} from './WaypointPreviewList';

/** How many waypoints are shown unlocked before the rest collapse into a "N more" summary row. */
export const PREVIEW_LIMIT = 3;

/**
 * Custom hook for the `WaypointPreviewList` component.
 * Splits waypoints into the always-visible group and the collapsible hidden group,
 * and tracks whether the hidden group is currently expanded.
 *
 * @param waypoints Array of waypoint preview items.
 * @param testId    The list's `testId`, used to derive the hidden group's element ID.
 * @returns The visible/hidden waypoint groups, expand state, and translation function.
 */
export const useWaypointPreviewList = (waypoints: WaypointPreview[], testId: string) => {
    const {t} = useTranslation();
    const [expanded, setExpanded] = useState(false);

    return {
        expanded,
        hiddenGroupId: `${testId}-hidden`,
        hiddenWaypoints: waypoints.slice(PREVIEW_LIMIT),
        setExpanded,
        t,
        visibleWaypoints: waypoints.slice(0, PREVIEW_LIMIT)
    };
};